import { initializeHintClickTracking } from './hint-tracking';

export const initializeSegmentInputTooltips = ({
  controller,
  $scope,
  adTooltipsService,
  adAnalyticsCategory,
  tooltipsKey,
  trackingLabel,
  popupService,
  isMobile,
}) => {
  controller.isHintTrackingInitialized = false;
  controller.unsubscribeHintListener = null;

  controller.updateTooltips = () => {
    if (!controller.ad.category) {
      return;
    }

    controller.tooltipText = '';

    controller.isHintTrackingInitialized = false;

    if (controller.unsubscribeHintListener) {
      controller.unsubscribeHintListener();
    }

    adTooltipsService
      .getCategoryTooltips(
        controller.ad.category,
        controller.ad.isByHomeowner,
        controller.isUtilitiesTermsNotRequiredInRegion,
      )
      .then(tooltips => {
        controller.tooltipText = tooltips[tooltipsKey] || '';

        if (!controller.isHintTrackingInitialized) {
          setTimeout(
            () =>
              (controller.unsubscribeHintListener = initializeHintClickTracking(trackingLabel, adAnalyticsCategory)),
            0,
          );
        }

        controller.isHintTrackingInitialized = true;
      });
  };

  controller.openTooltipModal = () => {
    if (!isMobile) {
      return;
    }

    popupService.openPopup('hint', {
      text: controller.tooltipText,
      title: angular.isFunction(controller.modalHintTitle)
        ? controller.modalHintTitle()
        : controller.modalHintTitle || 'Подсказка',
      hideCloseButton: false,
    });
  };

  controller.updateTooltips();

  $scope.$on('$destroy', () => {
    if (controller.unsubscribeHintListener) {
      controller.unsubscribeHintListener();
    }
  });

  $scope.$watch(() => controller.ad.category, controller.updateTooltips);
  $scope.$watch(() => controller.ad.isByHomeowner, controller.updateTooltips);
  $scope.$watch(() => controller.isUtilitiesTermsNotRequiredInRegion, controller.updateTooltips);
};
